import { render, staticRenderFns } from "./test_tag_list.vue?vue&type=template&id=b084c57a&scoped=true&"
import script from "./test_tag_list.vue?vue&type=script&lang=js&"
export * from "./test_tag_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b084c57a",
  null
  
)

export default component.exports